import React from 'react';
import { Navigate } from 'react-router-dom';

const ProtectedRoutes = ({ children }) => {
  const token = localStorage.getItem('token');

  // Redirect to login if not authenticated
  // if (token) {
  //   return <Navigate to="/dashboard" />;
  // }
  if (!token) {
    return <Navigate to="/login" />;
  }
  // If authenticated, render the component
  return children;
};

export default ProtectedRoutes;





// import React from 'react';
// import { Navigate } from 'react-router-dom';

// const ProtectedRoutes = ({ children, allowedRoles }) => {
//   const token = localStorage.getItem('token');
//   // const userRole = localStorage.getItem('role');



//   // const getHomePath = () => {
//   //   console.log(userRole)
//   //   switch (userRole) {
//   //     case 'Admin':
//   //       return '/home';
//   //     case 'Client':
//   //       return '/client/home';
//   //     case 'Agent':
//   //       return '/agent/home';
//   //     default:
//   //       return '/login';
//   //   }
//   // };

//   // Redirect to login if not authenticated
//   if (!token) {
//     return <Navigate to="/login" />;
//   }
//   // Redirect to login if the user's role is not allowed
//   if (!allowedRoles.includes(userRole)) {
//     return <Navigate to={getHomePath()} />;
//   }

//   // If authenticated and authorized, render the component
//   return children;
// };

// export default ProtectedRoutes;

